import React from 'react';

import FormLabel from '../FormLabel';
import ErrorNotice from '../ErrorNotice';
import { generateClassName, generateErrors } from '@javascript/util';

const InputField = (props) => {
  const {
    charLimit = null,
    disabled = false,
    error = [],
    idPrefix = null,
    inputClass = null,
    labelKlass = null,
    maxLength = null,
    min = null,
    mobileSubLabel = null,
    onBlur = null,
    onKeyDown = () => {},
    placeholder = null,
    required = false,
    subtext = null,
    textMask = null,
    spanKlass = '',
    tooltip = null,
    type = 'text',
    value = '',
    handleChange,
    id,
    klass,
    label,
    pattern,
    subTextClassName,
  } = props;

  const fieldId = ['fb'];
  if (idPrefix) {
    fieldId.push(idPrefix);
  }
  fieldId.push(id);

  const charlimitError = charLimit && value.length > charLimit;
  const className = generateClassName(klass);
  const { errorMessage, errorBool } = generateErrors(error);
  const charLimitClass = ['char-limit'];
  if (charlimitError) {
    charLimitClass.push('error');
  }

  const charLimitText = `${value.length}/${charLimit}`;

  return (
    <div className={className}>
      <FormLabel
        label={label}
        htmlFor={id}
        klass={labelKlass}
        spanKlass={spanKlass}
        tooltip={tooltip}
        mobileSubLabel={mobileSubLabel}
        required={required}
      >
        <input
          type={type}
          id={fieldId.join('-')}
          name={id}
          error={errorBool}
          placeholder={placeholder || ''}
          onBlur={onBlur}
          value={textMask ? textMask(value) : value}
          pattern={pattern}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
          min={min}
        />
        {subtext && (
          <span className={`${subTextClassName} subtext`}>{subtext}</span>
        )}
      </FormLabel>
      <ErrorNotice error={errorMessage}>
        {charLimit && (
          <span className={charLimitClass.join(' ')}>{charLimitText}</span>
        )}
      </ErrorNotice>
    </div>
  );
};

export default InputField;
